import {
  getAdminFeatureAccessSettings,
  getAdminFeatureAccessSettingsStatus,
  getCanEditNetworkQuestionSettings,
  getCanEditNetworkQuestionsOnlyMode,
  getViewerCanAccessAnalyticsAdminSettings,
  getViewerCanEditCampaignAnalyticsSettings,
  getViewerCanEditLeaderSettings,
  getViewerCanEditLeadershipAnalyticsSettings,
  getViewerCanEditNetworkQuestionAnalyticsSettings,
  getViewerCanManageComplianceData,
  getViewerCanManageMultiTenantOrganizationPolicy,
  getViewerCanManageViewOnlyModeUsers,
} from '@ms/yammer-data/dist/domains/adminFeatureAccessSettings/selectors';
import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useSelector } from '../useSelector';

type UseAdminFeatureAccessSettings = () => ReturnType<typeof getAdminFeatureAccessSettings>;
export const useAdminFeatureAccessSettings: UseAdminFeatureAccessSettings = () =>
  useSelector(getAdminFeatureAccessSettings);

type UseAdminFeatureAccessSettingsStatus = () => ReturnType<typeof getAdminFeatureAccessSettingsStatus>;
export const useAdminFeatureAccessSettingsStatus: UseAdminFeatureAccessSettingsStatus = () =>
  useSelector(getAdminFeatureAccessSettingsStatus);

type UseViewerCanEditAnalyticsSettings = () => boolean;
export const useViewerCanAccessAnalyticsAdminSettings: UseViewerCanEditAnalyticsSettings = () =>
  useSelector(getViewerCanAccessAnalyticsAdminSettings);

type UseViewerCanEditLeadershipAnalyticsSettings = () => boolean;
export const useViewerCanEditLeadershipAnalyticsSettings: UseViewerCanEditLeadershipAnalyticsSettings = () =>
  useSelector(getViewerCanEditLeadershipAnalyticsSettings);

type UseViewerCanEditCampaignAnalyticsSettings = () => boolean;
export const useViewerCanEditCampaignAnalyticsSettings: UseViewerCanEditCampaignAnalyticsSettings = () =>
  useSelector(getViewerCanEditCampaignAnalyticsSettings);

type UseViewerCanEditNetworkQuestionAnalyticsSettings = () => boolean;
export const useViewerCanEditNetworkQuestionAnalyticsSettings: UseViewerCanEditNetworkQuestionAnalyticsSettings = () =>
  useSelector(getViewerCanEditNetworkQuestionAnalyticsSettings);

type UseCanEditNetworkQuestionSettings = () => boolean;
export const useCanEditNetworkQuestionSettings: UseCanEditNetworkQuestionSettings = () =>
  useSelector(getCanEditNetworkQuestionSettings);

type UseCanEditNetworkQuestionsOnlyMode = () => boolean;
export const useCanEditNetworkQuestionsOnlyMode: UseCanEditNetworkQuestionsOnlyMode = () =>
  useSelector(getCanEditNetworkQuestionsOnlyMode);

type UseCanViewerEditLeaderSettings = () => boolean;
export const useCanViewerEditLeaderSettings: UseCanViewerEditLeaderSettings = () =>
  useSelector(getViewerCanEditLeaderSettings);

type UseViewerCanManageComplianceData = () => boolean;
export const useViewerCanManageComplianceData: UseViewerCanManageComplianceData = () =>
  useSelector(getViewerCanManageComplianceData);

type UseAdminCanEditViewOnlyMode = () => boolean;
export const useAdminCanEditViewOnlyMode: UseAdminCanEditViewOnlyMode = () => {
  const isRestrictedUserFlightEnabled = useExperimentTreatmentWithoutReporting(Experiment.RestrictedUser) === true;
  const viewerCanManageViewOnlyModeUsers = useSelector(getViewerCanManageViewOnlyModeUsers);

  return isRestrictedUserFlightEnabled && viewerCanManageViewOnlyModeUsers;
};

type UseViewerCanManageMultiTenantOrganizationPolicy = () => boolean;
export const useViewerCanManageMultiTenantOrganizationPolicy: UseViewerCanManageMultiTenantOrganizationPolicy = () => {
  const isMTOPolicyAdminPageExperimentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.MTOPolicyEngageAdminPortalPage) === true;
  const viewerCanManageMultiTenantOrganizationPolicy = useSelector(getViewerCanManageMultiTenantOrganizationPolicy);

  return isMTOPolicyAdminPageExperimentEnabled && viewerCanManageMultiTenantOrganizationPolicy;
};
